import React from "react"
import Helmet from "react-helmet"

import { applyImageCloudinaryTransforms } from "utils/applyCloudinaryTransforms"

/**
 * Pushes <link rel="preload" as="image" ... /> into the document HEAD (one for
 * each image variation), allowing faster loading of above-the-fold images.
 */
const ImagePreload = ({ baseUrl, images }) => {
  // sort by descending screen size first
  const sizes = [...images]
  sizes.sort((a, b) => (b.screenSize || 0) - (a.screenSize || 0))

  const links = sizes.map(({ url, screenSize, transforms }, idx) => {
    const url1x = applyImageCloudinaryTransforms(url || baseUrl, transforms)
    const url2x = applyImageCloudinaryTransforms(url || baseUrl, transforms.concat("/dpr_2.0"))
    const maxWidth = idx > 0 ? ` and (max-width: ${sizes[idx - 1].screenSize - 1}px)` : ""

    return [
      {
        rel: "preload",
        as: "image",
        media: screenSize
          ? `(min-width: ${screenSize}px)${maxWidth} and (max-device-pixel-ratio: 2)`
          : maxWidth,
        href: url1x,
      },
      {
        rel: "preload",
        as: "image",
        media: screenSize
          ? `(min-width: ${screenSize}px)${maxWidth} and (min-device-pixel-ratio: 2)`
          : `${maxWidth} and (min-device-pixel-ratio: 2)`,
        href: url2x,
      },
    ]
  })

  return <Helmet link={links?.flat() ?? []} />
}

export default ImagePreload
